import DataTable from "@/components/admin/DataTable";
import { adminApi } from "@/lib/adminApi";

const columns = [
  { key: "created_at", label: "Inscrit le", format: "date" },
  { key: "email", label: "Email" },
];

export default function NewsletterList() {
  return (
    <DataTable
      testId="admin-newsletter"
      title="Newsletter"
      subtitle="Inscrits via le footer du site."
      fetcher={adminApi.listNewsletter}
      columns={columns}
    />
  );
}
